import React, { useEffect, useState, useMemo } from 'react'
import styled from 'styled-components';
import moment from 'moment';

import { FilterBox, SmallInfoPanel, HistoryChartsPanel, DailyChartPanel, HeatMapPanel, ReviewsPanel } from '../components/dashboard';

import { PieChartsPanel } from '../components/dashboard/PieChartsPanel';
import { PostSaleInfoPanel } from '../components/dashboard/PostSaleInfoPanel';
import { RankingsPanel } from '../components/dashboard/RankingsPanel';
import { useStore } from '../providers/store.provider';
import { SelectMultistore } from '../components/select-multistore/select-multistore.component';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Col1 = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;
`

const DashboardPage = () => {

    const storeProvider = useStore();

    const defaultDates = useMemo(() => ({
        initial: moment().startOf('month').toDate(),
        final: moment().endOf('month').toDate()
    }), []);

    const [filterDates, setFilterDates] = useState(defaultDates);
    const [isMultistore, setIsMultistore] = useState(storeProvider.getMultistoreState());

    const selectedMultistore = storeProvider.selectedMultistore?.id;
    const mergeFilters = { ...filterDates, storeId: selectedMultistore };

    useEffect(() => {
        setIsMultistore(storeProvider.getMultistoreState())
    }, [storeProvider])

    const handleFilter = ({ initial, final }) => {
        setFilterDates({ initial, final })
    }

    return (
        <Wrapper>
            {
                (!isMultistore || !(isMultistore && !selectedMultistore)) ? (
                    <>
                        <Col1>
                            <FilterBox defaultDates={defaultDates} onFilter={handleFilter} />
                        </Col1>
                        <SmallInfoPanel filterDates={mergeFilters} />
                        <HistoryChartsPanel filterDates={mergeFilters} />
                        <DailyChartPanel filterDates={mergeFilters} />
                        <PieChartsPanel filterDates={mergeFilters} />
                        <HeatMapPanel filterDates={mergeFilters} />
                        <PostSaleInfoPanel filterDates={mergeFilters} />
                        <ReviewsPanel filterDates={mergeFilters} />
                        <RankingsPanel filterDates={mergeFilters} />
                    </>
                ) :
                    (
                        <SelectMultistore />
                    )
            }
        </Wrapper>
    )
}

export default DashboardPage